import React from 'react';
import { Button, Box } from '@mui/material';

interface AssessmentStepControButtonGroupProps {
  isLast: boolean;
  isFirst: boolean;
  handleNext: () => void;
  handleBack: () => void;
  handleSubmit: () => void;
  handleSave?: () => void;
  showSaveBtn?: boolean;
}

const AssessmentStepControButtonGroup: React.FC<
  AssessmentStepControButtonGroupProps
> = ({
  isLast,
  isFirst,
  handleBack,
  handleNext,
  handleSubmit,
  handleSave,
  showSaveBtn = true,
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      <div>
        {showSaveBtn ? (
          <Button
            variant="contained"
            onClick={handleSave}
            className="save-btn"
            sx={{ mt: 1, mr: 1 }}
          >
            Save
          </Button>
        ) : null}
        {isLast ? (
          <Button
            variant="contained"
            onClick={handleSubmit}
            className="finish-btn"
            sx={{ mt: 1, mr: 1 }}
          >
            Submit
          </Button>
        ) : (
          <Button
            variant="contained"
            onClick={handleNext}
            sx={{ mt: 1, mr: 1 }}
          >
            Continue
          </Button>
        )}
        <Button disabled={isFirst} onClick={handleBack} sx={{ mt: 1, mr: 1 }}>
          Back
        </Button>
      </div>
    </Box>
  );
};

export default AssessmentStepControButtonGroup;
